import { MappedClass, MappedProperty, MappedPropertyArray } from '@h5s/util-object';
import { CashRegister } from './cash-register';

@MappedClass()
export class DataGroupedByOwnerCorporateData {
  @MappedProperty()
  cashRegisterFiscalClosureAllowed: boolean;

  @MappedPropertyArray(() => CashRegister)
  cashRegisters: CashRegister[];

  @MappedProperty()
  ownerCorporateDataId: number;
}
